import React, { useState } from "react";
import Modal from "../../../../components/modals/Modal";
import { BsSliders } from "react-icons/bs";
import { doc, updateDoc } from "firebase/firestore";
import { firestore } from "../../../../firebase/config";
import { POINTS_FOR_WIN } from "../../../../constants";

const AdjustPoints = ({ tournament, tournamentId }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pointsPerWin, setPointsPerWin] = useState(
    tournament.pointsPerWin ?? POINTS_FOR_WIN
  );
  const [headToHeadEnabled, setHeadToHeadEnabled] = useState(
    tournament.headToHead ?? false
  );

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const writePoints = async () => {
    const tournamentRef = doc(firestore, "tournaments", tournamentId);

    try {
      await updateDoc(tournamentRef, {
        pointsPerWin: pointsPerWin,
        headToHead: headToHeadEnabled,
      });
      toggleModal();
      window.location.reload();
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <>
      <BsSliders
        className="w-10 h-10 border-2 border-black p-1.5 cursor-pointer rounded"
        onClick={() => toggleModal()}
      />

      <Modal
        isOpen={isModalOpen}
        title="Adjust Points"
        subtitle="Change how many points are awarded for a win"
        onCancel={toggleModal}
        onConfirm={writePoints}
      >
        <label className="text-lg font-medium text-gray-800">
          Points per Win:{" "}
        </label>
        <select
          defaultValue={pointsPerWin}
          onChange={(event) => setPointsPerWin(Number(event.target.value))}
        >
          <option value={2}>2</option>
          <option value={3}>3</option>
          <option value={4}>4</option>
          <option value={5}>5</option>
        </select>

        <label
          htmlFor={"enable-head-to-head"}
          className="flex items-center mt-4 space-x-2 cursor-pointer"
        >
          <input
            type="checkbox"
            id={"enable-head-to-head"}
            checked={headToHeadEnabled}
            onChange={() => setHeadToHeadEnabled(!headToHeadEnabled)}
            className="h-4 w-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500 cursor-pointer"
          />
          <div className="flex flex-col">
            <span className="text-gray-700">
              {"Enable head to head as a tiebreaker"}
            </span>
            <span className="text-xs text-gray-700">
              {
                "If more than 2 teams have equal record it will default to goal difference"
              }
            </span>
          </div>
        </label>
      </Modal>
    </>
  );
};

export default AdjustPoints;
